import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

import InfoBubbles from './bubbles.js'
import Info from '../info.js'
import '../../css/main-components/triangles.css'

export default class InfoTriangles extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			index: ''
		};
	}
	
	handleMouseOver(section, index){
		document.getElementById('info-bubbles').style.opacity = '1';
		document.getElementById('info-bubbles').style.transition = 'all 0.5s';
		
		this.setState({
			index: index
		});
	}
	
	handleMouseLeave(){
		document.getElementById('info-bubbles').style.opacity = '0';
		document.getElementById('info-bubbles').style.transition = 'all 0.5s';
	}
	
	render(){
		
		let trianglesMap = [1,2,3,4,5,6,7,8]
		var infoG = Object.values(Info);
		
		return (
		<div id="info-triangles">
			{trianglesMap.map((i) => (
				<div 
					className={`triangle-${i} ${i === 2 || i === 4 || i === 7 ? 'der' : ''}`} 
					key={i}
				>
					
					<div className="triangle-text">
						{	
							(i === 1) || (i === 2) || (i === 3) || (i === 4) || (i === 6)
								?	<div className="triangle-contacto">
										{
											this.props.section === 'contacto' 
											? 	<NavLink
													to={infoG[i === 6 ? i-2 : i-1].path}
													activeClassName="sidebarIconSelected"
												>
													<img 
														src={`../../img/resources/burbuja-${infoG[i === 6 ? i-2 : i-1].icon}`}
														className="contacto-iconos"
													/>
												</NavLink>
											: this.props.info.triangles[i]
										}
									</div>
								: ''
						}
						{	
							i === 5
								?	<div className="triangle-text-5">
										<a 
											href="http://www.fraccionamientolomablanca.com.mx/"
											target="_blank"
										>
											<img 
												src="../../img/resources/logo-loma-blanca.png"
											/>
										</a>
									</div>
								: ''
						}
						{	
							i === 8
								?	<div className="triangle-text-8">
										Fundador: <br/>
										Lic. Jacobo Aguilar
									</div>
								: ''
						}
						{ 
							i === 7 
							? <div className="triangle-text-7">
									<div className="text-container">
									<img
										src="../../img/resources/ICONO-NOSOTROS.png"
										alt="Quienes somos"
									/>
									<div className="text-small">
										Quienes somos.<br/><br/>
										Somos una empresa mexicana con más de 20 años de experiencia 
										ofreciendo soluciones de
									</div>
									<div className="text-large">
										 renta y venta de maquinaria pesada, 
										demoliciones, excavaciones, limpieza y nivelaciones.
										<br/><br/>
										Nuestro trabajo, respaldado por el mejor y más completo 
										inventario de maquinaria, es siempre reconocido por
									</div>
									<div className="text-small">
										 nuestros 
										clientes por su calidad, seguridad y mejor precio del mercado.
									</div>
									</div>
								</div>
							
							: ''
						}
						

					</div>
					
					<img 
						src="../../img/resources/BOTON-VERTICE-2.png"
						className="info-button"
						alt="info button"
						onMouseOver={() => this.handleMouseOver(this.props.section, i)}
						onMouseLeave={() => this.handleMouseLeave(this.props.section, i)}
						style={
							{
								display: i === 5 
								|| i === 7 
								|| i === 8 
								|| this.props.section === 'home'
								|| this.props.section === 'contacto'
								? 'none' : 'block' 
							}}
					/>
				</div>
			))}
			
			{ this.props.section === 'contacto'
				? ''
				: <InfoBubbles 
					section = {this.props.section}
					info = {this.props.info}
					index = {this.state.index === '' ? 1 : this.state.index}
				/>
			}
		</div>
	)}
}



// WEBPACK FOOTER //
// ./src/components/main-components/triangles.js